/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    var module = this;

    module.sliderSettingsObject = {
        intro: {
            // loop: true,
            simulateTouch: true,
            allowTouchMove: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slideToClickedSlide: false,
            followFinger: false,
            hashNavigation: true,
            virtualTranslate: true,
            on: {
                init: function () {
                    var body = document.body;
                    var swiper = this;
                    var introCapElements = document.querySelectorAll(".intro__cap");
                    var sliderName = this.$el[0].getAttribute("data-slider-name");
                    var params = this.params;
                    var disabledTabs = document.querySelectorAll(".js-disabled-tabs");
                    var viewport = itsoftApp.utils.getViewportSize();
                    var desktopSize = 1280;
                    params.microbe = document.querySelector(".intro__bg-item");
                    params.onMicrobeHide = function () {
                        if (body.classList.contains("js-anim-cap")) {
                            body.classList.remove("js-anim-cap");
                        }

                        if (body.classList.contains("js-anim")) {
                            body.classList.remove("js-anim");
                        }

                        body.classList.add("js-anim-next");
                        params.microbe.removeEventListener("animationend", params.onMicrobeHide);
                        params.microbe.addEventListener("animationend", params.onMicrobeShow);
                    }

                    params.onMicrobeShow = function () {
                        body.classList.remove("js-anim-next");
                        swiper.slides[0].querySelector(".intro__pack-container").addEventListener("click", swiper.params.onActiveSlideClick);
                        swiper.slides[1].querySelector(".intro__pack-container").addEventListener("click", swiper.params.onActiveSlideClick);
                        params.microbe.removeEventListener("animationend", params.onMicrobeShow);
                    }

                    if (sliderName) {
                        itsoftApp.modules.slidersLibrary.sliders[sliderName] = swiper;
                    }

                    if (viewport >= desktopSize) {
                        swiper.params.onActiveSlideClick = function (evt) {
                            // evt.currentTarget.removeEventListener("click", swiper.params.onActiveSlideClick);
                            swiper.params.allowTouchMove = true;
                            swiper.slides[0].querySelector(".intro__pack-container").removeEventListener("click", swiper.params.onActiveSlideClick);
                            swiper.slides[1].querySelector(".intro__pack-container").removeEventListener("click", swiper.params.onActiveSlideClick);
                            // swiper.slides[0].classList.add("js-disabled-slide");
                            // swiper.slides[1].classList.add("js-disabled-slide");
                            // if (disabledTabs.length > 0) {
                            //     Array.prototype.forEach.call(disabledTabs, function (disabledTabsItem) {
                            //         disabledTabsItem.classList.add("js-disabled-tabs");
                            //     });
                            // }
                            // if (body.classList.contains("js-anim-pale")) {
                            //     body.classList.remove("js-anim-pale");
                            // }
                            params.microbe.addEventListener("animationend", params.onMicrobeHide);
                            body.classList.add("js-anim-cap");
                        }
                    }

                    this.params.customIndications = this.$el[0].closest(".js-slider").querySelectorAll(".js-custom-indication");
                    this.params.customButtonActive = this.$el[0].closest(".js-slider").querySelector(".js-custom-button.js-active");
                    this.params.customButtons = this.$el[0].closest(".js-slider").querySelectorAll(".js-custom-button");

                    if (viewport >= desktopSize) {
                        Array.prototype.forEach.call(introCapElements, function (introCap) {
                            introCap.addEventListener("animationstart", function (evt) {
                                body.classList.add("js-one-time");
                                if (body.classList.contains("js-cap-visible")) {
                                    body.classList.remove("js-cap-visible");
                                }
                                body.classList.add("js-anim");
                                // if (body.classList.contains("js-anim")) {
                                //     body.classList.remove("js-anim");
                                // }
                                // if (body.classList.contains("js-anim-next")) {
                                //     body.classList.remove("js-anim-next");
                                // }
                            });

                            introCap.addEventListener("animationend", function (evt) {
                                var activeIndex = swiper.activeIndex;
                                swiper.params.activeSlideItem = swiper.slides[activeIndex];
                                if (body.classList.contains("js-anim-cap")) {
                                    body.classList.remove("js-anim-cap");
                                }

                                // swiper.params.activeSlideItem.addEventListener("click", swiper.params.onActiveSlideClick);
                                swiper.params.allowTouchMove = false;
                                swiper.params.slideToClickedSlide = true;
                            });

                            params.microbe.addEventListener("animationend", params.onMicrobeHide);
                        });

                        // body.classList.add("js-anim");
                    }

                    setTimeout(function () {
                        params.hashNavigation = false;

                        if (disabledTabs.length > 0) {
                            Array.prototype.forEach.call(disabledTabs, function (disabledTabsItem) {
                                disabledTabsItem.classList.remove("js-disabled-tabs");
                            });
                        }

                        swiper.slides[0].classList.remove("js-disabled-slide");
                        swiper.slides[1].classList.remove("js-disabled-slide");

                        swiper.slides[0].querySelector(".intro__pack-container").addEventListener("click", swiper.params.onActiveSlideClick);
                        swiper.slides[1].querySelector(".intro__pack-container").addEventListener("click", swiper.params.onActiveSlideClick);
                        swiper.params.slideToClickedSlide = true;

                        // if (viewport >= desktopSize) {
                        //     body.classList.add("js-anim-cap");
                        // }
                    }, 1000);
                },
                slideChange: function () {
                    var body = document.body;
                    var swiper = this;
                    var viewport = itsoftApp.utils.getViewportSize();
                    var desktopSize = 1280;
                    var params = this.params;
                    if (body.classList.contains("js-one-time")) {
                        params.microbe.removeEventListener("animationend", params.onMicrobeHide);
                        params.microbe.removeEventListener("animationend", params.onMicrobeShow);
                        swiper.slides[0].querySelector(".intro__pack-container").addEventListener("click", swiper.params.onActiveSlideClick);
                        swiper.slides[1].querySelector(".intro__pack-container").addEventListener("click", swiper.params.onActiveSlideClick);
                        if (body.classList.contains("js-anim-cap")) {
                            body.classList.remove("js-anim-cap");
                        }

                        if (body.classList.contains("js-anim")) {
                            body.classList.remove("js-anim");
                        }

                        if (body.classList.contains("js-anim-next")) {
                            body.classList.remove("js-anim-next");
                        }
                    }

                    swiper.params.slideToClickedSlide = false;

                    setTimeout(function () {
                        swiper.params.slideToClickedSlide = true;
                    }, 500);

                    setTimeout(function () {
                        var activeIndex = swiper.activeIndex;
                        var currentSlide = swiper.slides[activeIndex];

                        if (viewport >= desktopSize) {
                            // swiper.params.activeSlideItem = currentSlide;
                        }
                        // var currentSlide = swiper.slides[swiper.activeIndex];
                        if ("#" + currentSlide.getAttribute("data-hash") !== location.hash) {
                            if (viewport >= desktopSize) {
                                // swiper.params.activeSlideItem.addEventListener("click", swiper.params.onActiveSlideClick);
                            }

                            itsoftApp.modules.toggleTabs.callback.goToHash(currentSlide.getAttribute("data-hash"), "slider");
                        }
                    }, 10)
                }
            }
            // on: {
            //     init: function () {
            //         var swiper = this;
            //         var sliderContainer = this.$el[0];

            //         this.params.customButtonActive = this.$el[0].closest(".js-custom-buttons-section").querySelector(".swiper-slide.js-active .js-custom-button");
            //         this.params.customButtons = this.$el[0].closest(".js-custom-buttons-section").querySelectorAll(".js-custom-button");
            //         Array.prototype.forEach.call(this.params.customButtons, function (button, index) {
            //             // button.setAttribute("data-slide-to", index);
            //             button.addEventListener("click", function (evt) {
            //                 evt.preventDefault();
            //                 swiper.slideTo(index);
            //             })
            //         });
            //     },

            //     slideChangeTransitionEnd: function () {
            //         var swiper = this;
            //         var activeIndex = this.activeIndex;
            //         if (this.params.customButtonActive) {
            //             this.params.customButtonActive.closest(".swiper-slide").classList.remove("js-active");
            //         }
            //         this.params.customButtonActive = this.params.customButtons[activeIndex];
            //         if (this.params.customButtonActive) {
            //             this.params.customButtonActive.closest(".swiper-slide").classList.add("js-active");
            //         }
            //         itsoftApp.modules.slidersLibrary.sliders.tabs.slideTo(activeIndex);
            //     }
            // }
        },

        testing: {
            autoHeight: true,
            allowTouchMove: false,
            simulateTouch: false,
            keyboard: {
                enabled: false
            },
            slidesPerView: 1,
            followFinger: true,
            on: {
                init: function () {
                    var swiper = this;
                    var sliderName = this.$el[0].getAttribute("data-slider-name");
                    if (sliderName) {
                        itsoftApp.modules.slidersLibrary.sliders[sliderName] = swiper;
                    }
                    swiper.params.answers = {
                        answer1: "",
                        answer2: ""
                    }
                    this.params.customIndications = this.$el[0].closest(".js-slider").querySelectorAll(".js-custom-indication");
                    this.params.customButtonActive = this.$el[0].closest(".js-slider").querySelector(".js-custom-button.js-active");
                    this.params.customButtons = this.$el[0].closest(".js-slider").querySelectorAll(".js-custom-button");
                    var links = this.$el[0].closest(".js-slider").querySelectorAll("[data-slide-to]");
                    this.params.links = links;
                    Array.prototype.forEach.call(links, function (link) {
                        var slideIndex = link.getAttribute("data-slide-to");

                        if (slideIndex) {
                            link.addEventListener("click", function (evt) {
                                evt.preventDefault();
                                var activeIndex = swiper.activeIndex;
                                if (evt.currentTarget.hasAttribute("data-answer-name")) {
                                    var answer = evt.currentTarget.getAttribute("data-answer-name");
                                    if (activeIndex == 0) {
                                        swiper.params.answers.answer1 = answer;
                                    } else if (activeIndex == 1) {
                                        swiper.params.answers.answer2 = answer;
                                    }

                                    var resultSlide = swiper.slides[2];


                                    if (swiper.params.answers.answer1 && swiper.params.answers.answer2) {
                                        if ((swiper.params.answers.answer1 === "a" && swiper.params.answers.answer2 === "b") || (swiper.params.answers.answer1 === "b" && swiper.params.answers.answer2 === "b")) {
                                            resultSlide.classList.add("testing__item--advance");
                                        } else if (resultSlide.classList.contains("testing__item--advance")) {
                                            resultSlide.classList.remove("testing__item--advance");
                                        }
                                    }
                                }
                                swiper.slideTo(+slideIndex);
                            })
                        }
                    })
                },

                slideChangeTransitionEnd: function () {
                    var swiper = this;
                    var activeIndex = this.activeIndex;
                    var customIndications = this.params.customIndications;
                    Array.prototype.forEach.call(customIndications, function (customIndication, index) {
                        if (index <= activeIndex && activeIndex != 2) {
                            customIndications[index].classList.add("js-active");
                        } else if (index <= activeIndex && activeIndex == 2) {
                            itsoftApp.modules.createCircle.progressBar.animate(1);
                            setTimeout(function () {
                                customIndications[index].classList.add("js-active");
                            }, 1700);
                        } else {
                            customIndications[index].classList.remove("js-active");
                        }
                    });

                    if (activeIndex == 0) {
                        itsoftApp.modules.createCircle.progressBar.animate(0);
                    } else if (activeIndex == 1) {
                        itsoftApp.modules.createCircle.progressBar.animate(0.5);
                    }
                }
            }
        }
    };
});